import { render, staticRenderFns } from "./base-block.vue?vue&type=template&id=a51c7f42&scoped=true&"
import script from "./base-block.vue?vue&type=script&lang=js&"
export * from "./base-block.vue?vue&type=script&lang=js&"
import style0 from "./base-block.vue?vue&type=style&index=0&id=a51c7f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c7f42",
  null
  
)

export default component.exports